import { createStore } from "vuex";
import auth from "./modules/auth";
import permissions from "./modules/permissions";
import experiments from "./modules/experiments";
import applications from "./modules/applications";
import platforms from "./modules/platforms";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootState {}

export default createStore<RootState>({
  modules: { auth, permissions, experiments, applications, platforms },
});
